(function checkoutScript($, Drupal) {
  Drupal.behaviors.checkout = {
    attach() {

      // Improves layout by putting Other textfield inside radios wrapper.
      $('.checkout .js-form-item-donation-details-amount-other').appendTo('.checkout #edit-donation-details-amount-select');
      // Adds placeholder text to Other Amount input for clarity.
      $('.checkout #edit-donation-details-amount-other').attr('placeholder', 'Enter Amount');
    }
  };
}(jQuery, Drupal));
